import { useAccount } from 'modules/taboola-common-frontend-modules/account-configurations';

export const LandingPagesTaboolaPixelCellRenderer = ({ value }) => {
    const { id, parentNetworkAccountId } = useAccount();
    const numValue = value && Number(value);
    let res = `Unknown (${value})`;

    if (numValue === parentNetworkAccountId) {
        res = `Network (${value})`;
    } else if (numValue === id) {
        res = `Account (${value})`;
    }

    return res;
};

export default LandingPagesTaboolaPixelCellRenderer;
